import AppRoutes from 'src/AppRoutes';

export type RewardType = {
  points: number;
  additionalpoints: number;
  additionalPoints?: number;
  redeemvalue: number;
  redeemValue?: number;
};

export type RewardCashType = {
  rewardCashId: string;
  rewardProgramId: string;
  pointsRequired: number;
  cashAmount: number;
  tierLevel: number;
  isDisabled: boolean;
  dateCreated: string;
  lastUpdated: string;
  type: RewardItemType;
};

export type RewardProductType = {
  rewardProductId: string;
  productId: string;
  upc: Array<string>;
  name: string;
  imageUrl: string;
  type: RewardItemType;
};

export enum RewardItemType {
  PRODUCT = 'PRODUCT',
  CASH = 'CASH',
}

type RewardsParams = {
  refreshRewards?: boolean;
  suppressRedirect?: boolean;
};
export type MainConsumerParamList = {
  [AppRoutes.RewardsScreen]: RewardsParams | undefined;
};
